/**
 * Kontaktdaten des SaniUp-Supports. Eine Quelle, damit Telefonnummer und Adresse nicht an fünf
 * Stellen leicht verschieden dastehen — genau das war der Zustand bis 2026-08-23 (die Nummer stand
 * nur im Telefon-Dialog der Seitenleiste, die Adresse als nacktes `mailto:` an vier Stellen).
 *
 * Werte aus dem Impressum auf saniup.de (Stand 2026-08-23); **die Support-Adresse ist bewusst
 * `help@`, nicht die `info@` aus dem Impressum** — sie landet im Support-Postfach statt in der
 * allgemeinen Eingangspost.
 */
export const SANIUP_HELP_EMAIL = 'help@saniup.de'

/** Anzeigeform der Festnetznummer, so wie sie im Impressum steht. */
export const SANIUP_TELEFON = '+49 251 2845 5300'

/** Dieselbe Nummer als `tel:`-Ziel — ohne Leerzeichen, sonst wählen manche Clients nicht. */
export const SANIUP_TELEFON_LINK = 'tel:+4925128455300'

/**
 * Erreichbarkeit und Antwortzeit — **beides nachgeschlagen, nicht ausgedacht.**
 *
 * Hier stand kurzzeitig „Montag bis Freitag, 8 bis 17 Uhr". Das war erfunden: SaniUp veröffentlicht
 * nirgends Servicezeiten, und eine Uhrzeit in der Kundenoberfläche ist eine Zusage. Übernommen ist
 * jetzt, was das Team selbst sagt — die bisherige Formulierung des Telefon-Dialogs („zu den
 * üblichen Geschäftszeiten") und das Antwortversprechen von saniup.de („Rückmeldung innerhalb von
 * 24 Stunden"). Wer das ändert, belegt es aus derselben Quelle statt zu schätzen.
 */
export const SANIUP_ERREICHBARKEIT = 'Zu den üblichen Geschäftszeiten'
export const SANIUP_ANTWORTZEIT = 'Rückmeldung innerhalb von 24 Stunden'

/**
 * Baut einen `mailto:`-Link mit vorbelegtem Betreff und Text. Beides wird encodiert; ein Betreff
 * mit Umlaut oder `&` zerlegt den Link sonst still (der Rest landet als weiterer Parameter).
 */
export function buildHelpMailto(subject: string, body?: string): string {
  const params = [`subject=${encodeURIComponent(subject)}`]
  if (body) {
    params.push(`body=${encodeURIComponent(body)}`)
  }
  return `mailto:${SANIUP_HELP_EMAIL}?${params.join('&')}`
}

/*
 * Fertige Fragen fuer das Support-Sheet (`SupportSheetService.oeffnen`), dort gestellt, wo die Frage
 * entsteht (Idee Tim 2026-10-07, Canvas „Support an der Fragestelle“). Der Assistent antwortet sofort,
 * ohne dass jemand tippt. Der Wortlaut zitiert, was auf dem Bildschirm steht: der Assistent sieht die
 * Seite zwar mit, aber nicht diesen Text.
 */

/** Die Frage der Grund-Karte einer Versorgung („Was muss ich tun?“). */
export function frageZumGrund(grund: string): string {
  return `Bei dieser Versorgung steht: «${klartext(grund)}» Warum geht es nicht weiter, und was muss ich tun?`
}

/** Die Frage des Fehlerdialogs („Was heißt das?“). Die Meldung darf HTML tragen, sie geht als Text hinein. */
export function frageZurMeldung(meldung: string): string {
  return `Ich bekomme die Meldung «${klartext(meldung)}» Was heißt das, und wie komme ich weiter?`
}

/**
 * Die Frage von „Wie funktioniert das?“ auf dem Reiter „Nächste Abrechnung“ (Leinwand „Jetzt
 * abrechnen · auf hohes Niveau“, Artboard „Support“). Die Seite erklaert sich ueber den Assistenten
 * statt ueber einen Erklaertext; der Wissensartikel dazu steht im Backend (`abrechnungszentrum-live.md`).
 */
export const FRAGE_NAECHSTE_ABRECHNUNG = 'Was mache ich auf dieser Seite, und was nicht?'

/** Tags raus, Leerraum auf je ein Leerzeichen. Die Meldungen sind unsere eigenen, ein Parser waere zu viel. */
function klartext(html: string): string {
  return html
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}
